import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export const useOpenApp = () => {
  const navigate = useNavigate();
  return async (app) => {
    try { await api.post("/logs/access", { app_id: app.app_id }); } catch { /* il log non blocca l'apertura */ }
    if (app.app_type === "integrated") navigate(`/app/${app.app_id}`);
    else if (app.app_type === "native") navigate(app.route || "/dashboard");
    else window.open(app.url, "_blank", "noopener,noreferrer");
  };
};
